var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Proptypes from 'prop-types';
import { v4 as uuid } from 'uuid';
export default function CheckButton(props) {
    var checkID = uuid();
    function clickHandler(e, id) {
        if (!props.disabled) {
            var cb = document.getElementById(id);
            if (e.target !== cb) {
                cb.checked = !cb.checked;
            }
            if (props.onChange) {
                props.onChange(cb.checked, props.value);
            }
        }
    }
    var spanStyle = {
        textAlign: 'left',
        paddingLeft: '7px',
    };
    return (_jsxs("button", __assign({ onClick: function (e) { return clickHandler(e, checkID); }, style: __assign({ backgroundColor: 'inherit', textAlign: 'left' }, props.style), className: props.className }, { children: [_jsx("input", { type: 'checkbox', defaultChecked: props.defaultChecked, id: checkID, value: props.value, style: { cursor: 'pointer', }, disabled: props.disabled, checked: props.checked, readOnly: props.checked !== undefined ? true : false }, void 0), _jsx("span", __assign({ style: spanStyle }, { children: props.children }), void 0)] }), void 0));
}
CheckButton.propTypes = {
    value: Proptypes.any,
    onChange: Proptypes.func,
    disabled: Proptypes.bool,
    checked: Proptypes.bool,
    style: Proptypes.object,
    className: Proptypes.string
};
//# sourceMappingURL=CheckButton.js.map